/**
 * Prime Big Deal Days: event dates, hero text and countdown. Mirrors lib/primeDay.js
 * on the server, which pre-renders the hero and navbar: keep the two identical,
 * or the page shifts when React takes over. Update both for each event.
 */
export const EVENT = {
  name: 'Prime Big Deal Days',
  year: 2026,
  startsAt: '2026-10-06T07:01:00Z', // Oct 6, 12:01 a.m. PT
  endsAt: '2026-10-08T06:59:00Z', //   Oct 7, 11:59 p.m. PT
  datesLabel: 'October 6–7, 2026',
};

export const PRIME_DAY_PATH = '/prime-big-deal-days';
export const PRIME_TRIAL_URL = 'https://www.amazon.com/amazonprime?tag=voiceshoppi0b-20';

export const HERO = {
  eyebrow: `${EVENT.name} · ${EVENT.datesLabel}`,
  title: `${EVENT.name} ${EVENT.year}: the deals worth buying`,
  intro: 'Hand-checked Amazon deals for Prime members: real price drops, top-rated products at 25%+ off, and promo codes that stack on top of the sale price. Updated every hour.',
};

export const eventStatus = (now = new Date()) => {
  if (now < new Date(EVENT.startsAt)) return 'upcoming';
  if (now <= new Date(EVENT.endsAt)) return 'live';
  return 'ended';
};

// The nav link and homepage banner stay up for a week after the event ends
const PROMOTE_UNTIL_MS = new Date(EVENT.endsAt).getTime() + 7 * 24 * 60 * 60 * 1000;
export const isPromoted = (now = new Date()) => now.getTime() < PROMOTE_UNTIL_MS;

/** "Starts in 3 days, 14 hours" / "Live now, ends in 5 hours, 2 minutes" / "…has ended…" */
export const countdownLabel = (now = new Date()) => {
  const status = eventStatus(now);
  if (status === 'ended') return `${EVENT.name} ${EVENT.year} has ended. The deals below are still live.`;
  const target = new Date(status === 'upcoming' ? EVENT.startsAt : EVENT.endsAt).getTime();
  const mins = Math.max(0, Math.round((target - now.getTime()) / 60000));
  const d = Math.floor(mins / 1440);
  const h = Math.floor((mins % 1440) / 60);
  const m = mins % 60;
  const unit = (n, w) => `${n} ${w}${n === 1 ? '' : 's'}`;
  let span = unit(m, 'minute');
  if (d > 0) span = `${unit(d, 'day')}, ${unit(h, 'hour')}`;
  else if (h > 0) span = `${unit(h, 'hour')}, ${unit(m, 'minute')}`;
  return status === 'upcoming' ? `Starts in ${span}` : `Live now, ends in ${span}`;
};
